"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedMessage = exports.default = void 0;
const getFormattedMessage = (message, minutes, seconds, duration) => {
  let timeUnit = seconds;
  let formattedDuration = +duration;
  if (+duration >= 60) {
    timeUnit = minutes;
    formattedDuration = +duration / 60;
  }
  return message.replace('{{duration}}', `${formattedDuration} ${timeUnit}`);
};
exports.getFormattedMessage = getFormattedMessage;
var _default = exports.default = {
  getFormattedMessage
};